module.exports = __webpack_public_path__ + "blacklungs.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacklungs.png
// module id = 859
// module chunks = 0